// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// Objeto global para almacenar instancias
window.scSwipers = {};

// Función para slides agrupados con fade en escritorio e individuales en mobile
function regroupSwiperSlides(swiperEl) {
    if (!swiperEl.dataset.groupMobile && !swiperEl.dataset.groupDesktop) return;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const items = Array.from(wrapper.children); // items sueltos ya renderizados por PHP
    const breakpoint = parseInt(swiperEl.dataset.breakpoint || '1024', 10);
    const groupDesktop = parseInt(swiperEl.dataset.groupDesktop || '1', 10);
    const groupMobile = parseInt(swiperEl.dataset.groupMobile || '1', 10);

    const isDesktop = window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
    const groupSize = isDesktop ? groupDesktop : groupMobile;

    wrapper.innerHTML = '';

    for (let i = 0; i < items.length; i += groupSize) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        const group = items.slice(i, i + groupSize);

        if (groupSize > 1) {
            const inner = document.createElement('div');
            inner.className = 'swiper-slide-wrapper';
            group.forEach(item => inner.appendChild(item)); // mueve el nodo real, no lo clona
            slide.appendChild(inner);
        } else {
            slide.appendChild(group[0]);
        }

        wrapper.appendChild(slide);
    }
}

/**
 * Imagenes diferidas en servidor (inc/swiper-lazy.php): en los carruseles con efecto fade
 * los slides a partir del tercero llegan con src, srcset y sizes aparcados en data-*.
 * Aqui se les devuelven a los slides del rango visible mas el siguiente, al iniciar y en
 * cada cambio de slide, para que el siguiente ya este cargando antes de que se vea. El
 * anterior solo a partir del primer cambio de slide: con loop el anterior del primero es
 * el ultimo, y al iniciar eso cargaba de mas el ultimo slide del hero (890 KB) y el
 * tercero de los carruseles de tres slides que estan bajo el pliegue. srcset y sizes van
 * antes que src: si src entra primero el navegador pide la imagen dos veces.
 */
function hydrateDeferredSlides(swiper, withPrevious = true) {
    const total = swiper.slides.length;

    if (!total || !swiper.el.querySelector('img[data-sc-defer]')) return;

    const perView = swiper.params.slidesPerView === 'auto'
        ? Math.ceil(swiper.slidesPerViewDynamic())
        : Math.ceil(swiper.params.slidesPerView || 1);

    const first = swiper.activeIndex - (withPrevious ? 1 : 0);

    for (let i = first; i <= swiper.activeIndex + perView; i++) {
        const slide = swiper.slides[((i % total) + total) % total];
        if (!slide) continue;

        slide.querySelectorAll('img[data-sc-defer]').forEach((img) => {
            ['srcset', 'sizes', 'src'].forEach((attr) => {
                const value = img.getAttribute('data-' + attr);
                if (value !== null) {
                    img.setAttribute(attr, value);
                    img.removeAttribute('data-' + attr);
                }
            });
            img.removeAttribute('data-sc-defer');
        });
    }
}

export function init_sc_swipers(context = document) {

    window.scSwipers = window.scSwipers || {};

    jQuery(context).find('.sc-swiper').each(function (index) {

        const $swiper = jQuery(this);
        let options = $swiper.data('options') || {};
        const id = $swiper.attr('id') || `swiper-${index}`;

        // Definimos bullets para ver si existen por cada slide
        const slideBullets = [...this.querySelectorAll('.sc-slider-tabs .swiper-slide')]
        .map(slide => slide.dataset.bullet)
        .filter(Boolean);

        

        // Si ya está inicializado, salir
        if (this.swiper) return;

        // Lllamada a función de reagrupar
        // Y aplicar si tiene la clase
        regroupSwiperSlides(this);

        // Forzar soporte trackpad horizontal (genérico para test)
/*         options = {
            ...options,
            freeMode: options.freeMode ?? true,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
                releaseOnEdges: true,
                ...(options.mousewheel || {})
            }
        }; */

         // Si hay bullets definidos, añadir render de paginación
        if (slideBullets.length) {
            options = {
                ...options,
                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    clickable: false,
                    renderBullet(index, className) {
                        const label = slideBullets[index] || index + 1;
                        const isLast = index === slideBullets.length - 1;
                        return `<div class="${className} "><a class="sc-button-link cursor-pointer !mr-0" data-slide-index="${index}"><span>${label}</span></a>${isLast ? '</div>' : '<span class="sc-bullet-separator">,</span></div>'}`;
                    },
                    ...(options.pagination || {})
                }
            };
        }

        // Crear instancia y guardar
        const instance = new Swiper(this, options);
        window.scSwipers[id] = instance;

        hydrateDeferredSlides(instance, false);
        instance.on('slideChange breakpoint', () => hydrateDeferredSlides(instance));

        const paginationEl = this.querySelector('.swiper-pagination');
        if (paginationEl && slideBullets.length) {
            paginationEl.addEventListener('click', (e) => {
                const bullet = e.target.closest('[data-slide-index]');
                if (!bullet) return;
                e.stopPropagation();
                const index = parseInt(bullet.dataset.slideIndex, 10);
                instance.slideToLoop(index);
            });
        }

        const cursorBreakpoint = parseInt(this.dataset.breakpoint || '1024', 10);
        const isDesktop = window.matchMedia(`(min-width: ${cursorBreakpoint}px)`).matches;

        // Cursor paginado — solo si tiene la clase
        if ($swiper.hasClass('custom-pagination-cursor') && isDesktop ) {
            initPaginatedCursor(this, instance);
        }
    });
}

function initPaginatedCursor(swiperEl, swiper) {

    // Buscar el cursor en el DOM en lugar de crearlo
    const cursor = swiperEl.querySelector('.sc-paginated-cursor');
    if (!cursor) return;

    // const swiperImgContainer = swiperEl.querySelector('.sc-paginated-cursor__label');

    const label = cursor.querySelector('.sc-paginated-cursor__label');

    function getTotal() {
        return swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    }

    // function updateLabel() {
    //     const total = getTotal();
    //     const current = swiper.realIndex + 1;
        
    //     if (cursor.classList.contains('is-prev')) {
    //         const prevIndex = current === 1 ? total : current - 1;
    //         label.textContent = `${prevIndex} / ${total}`;
    //     } else {
    //         const nextIndex = current === total ? 1 : current + 1;
    //         label.textContent = `${nextIndex} / ${total}`;
    //     }
    // }

    // updateLabel();
    swiper.on('slideChange');

    /* La flecha se mezcla con el fondo (invert + mix-blend-difference, en pagination.css) solo
       cuando esta encima de una imagen; en el resto del carrusel se queda negra. Sobre el
       blanco de la pagina la mezcla devolvia un gris sin contraste.

       El hit-test es elementsFromPoint y no e.target porque los slides llevan enlaces, degradados
       y capas de texto por encima de la foto: con e.target la flecha perdia la mezcla en cuanto
       pasaba por una de esas capas aunque siguiera sobre la imagen. Se recorre la pila de
       arriba abajo y se para al salir del carrusel, que es donde acaban los slides. */
    const MEDIA_SELECTOR = 'img, picture, video, canvas, svg';

    function isOverImage(x, y) {
        for (const el of document.elementsFromPoint(x, y)) {
            if (el === cursor || cursor.contains(el)) continue;
            if (!swiperEl.contains(el)) break;
            if (el.matches(MEDIA_SELECTOR)) return true;
            if (window.getComputedStyle(el).backgroundImage !== 'none') return true;
        }
        return false;
    }

    /* elementsFromPoint fuerza layout, asi que se mira una vez por frame y no en cada
       mousemove; la posicion del cursor si se actualiza siempre para que no arrastre. */
    let pendingPoint = null;
    let blendFrame = null;

    function scheduleBlendCheck(x, y) {
        pendingPoint = { x, y };
        if (blendFrame) return;
        blendFrame = requestAnimationFrame(() => {
            blendFrame = null;
            cursor.classList.toggle('is-over-image', isOverImage(pendingPoint.x, pendingPoint.y));
        });
    }

    swiperEl.addEventListener('mousemove', (e) => {
        const overVideo = e.target.closest('.block-video div, .video-js, .block-video-controls');
        cursor.classList.toggle('is-visible', !overVideo);

        const rect = swiperEl.getBoundingClientRect();

        /* Coordenadas de pantalla, no relativas al slider: el cursor va fijo al viewport
           para que el overflow del carrusel no lo recorte al llegar al borde. */
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;

        const isLeft = e.clientX < rect.left + rect.width / 2;

        cursor.classList.toggle('is-prev', isLeft);
        cursor.classList.toggle('is-next', !isLeft);

        scheduleBlendCheck(e.clientX, e.clientY);

        //  updateLabel(); 
    });

    swiperEl.addEventListener('mouseenter', () => {
        cursor.classList.add('is-visible');
    });

    swiperEl.addEventListener('mouseleave', () => {
        if (blendFrame) {
            cancelAnimationFrame(blendFrame);
            blendFrame = null;
        }
        cursor.classList.remove('is-visible', 'is-prev', 'is-next', 'is-over-image');
    });

    /* El clic escucha en todo el carrusel y no solo en la tira de slides: la flecha ya se
       enseña en todo él --el mousemove de arriba va sobre el mismo elemento--, y donde se ve
       la flecha se espera poder pasar de slide. Con el listener en .swiper-wrapper habia
       zonas, como la fila de pestañas, que enseñaban la flecha y no reaccionaban al clic.
       Los enlaces y botones siguen fuera por el guard de abajo, asi que las pestañas se
       comportan como lo que son. */
    swiperEl.addEventListener('click', (e) => {
        // Si el click viene del vídeo o su botonera, no navegues el slider
        if (e.target.closest('.block-video div, .video-js, .block-video-controls, a, button')) {
            return;
        }

        const { left, width } = swiperEl.getBoundingClientRect();
        const isLeft = e.clientX < left + width / 2;

        if (isLeft) {
            swiper.slidePrev();
        } else {
            swiper.slideNext();
        }
    });
}

// Exponer en el objeto window para evitar re-imports en otros archivos
window.init_sc_swipers = init_sc_swipers;